import React from 'react';
import { BrowserRouter as Router, Routes, Route, useParams } from 'react-router-dom';
import { HelmetProvider } from '@dr.pogodin/react-helmet';
import Home from './views/home';
import Donations from './views/donations';
import { CheckoutSuccess, CheckoutCancel } from './components/checkouts';
import NotFound from './views//404';
import ShirtPage from './views/shirt';
import CandlePreOrderPage from './views/candle';
import ChapterPage from './views/chapter';
import SubscribePage from './views/subscribe';
import Unsubscribe from './views/unsubscribe';
import ContactPage from './views/contact';
import TalkEditor from './views/editor';
import EditorPage from './views/EditorPage';
import Dashboard from './views/talkManager';
import EditChapter from './views/editChapter';
import SlideshowPage from './slideshow';
import RemoteControlPage from './views/remote';
import TalkPage from './views/talk';
import TalkPrint from './views/TalkPrint';
import Linktree from './links';
import LoginPage from './views/login';
import TalksGrid from './views/talkList';
import ProtectedRoute from './components/ProtectedRoute';
import UsersPage from './views/users';
import StartChapter from './views/start';
import Orders from './views/orders';
import HandoutView from './views/Handout';
import Email from './views/email';
import Pickup from './views/pickup';
import NationDashboard from './views/nationalDashboard';
import NewChapter from './views/newChapter.js';
import ChapterDashboard from './views/chapterDashboard.js';
import EditTrivia from './views/editTrivia.js';
import Trivia from './views/trivia.js';
import WelcomeScreen from './views/welcome';
const PdfDownload = () => {
  const { talkId } = useParams();
  React.useEffect(() => {
    if (!talkId) return;
    const url = `https://sole-pdf-1066934915181.us-central1.run.app/api/pdf/talk/${encodeURIComponent(talkId)}`;
    // Trigger download by navigating to the PDF URL
    window.location.assign(url);
  }, [talkId]);

  const fallbackUrl = `https://sole-pdf-1066934915181.us-central1.run.app/api/pdf/talk/${encodeURIComponent(talkId || '')}`;
  return (
    <div style={{ padding: '2rem' }}>
      <h2>Preparing your handout…</h2>
      <p>If your download doesn’t start automatically, <a href={fallbackUrl}>click here</a>.</p>
    </div>
  );
};
const App = () => {

  return (
    <HelmetProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/give" element={<Donations />} />
          <Route path="/success" element={<CheckoutSuccess />} />
          <Route path="/cancel" element={<CheckoutCancel />} />
          <Route path="/shirt" element={<ShirtPage />} />
          <Route path="/candle" element={<CandlePreOrderPage />} />
          <Route path="/tamu" element={<ChapterPage />} />
          <Route path="/subscribe" element={<SubscribePage />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
          <Route path="/pickup" element={<Pickup />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/start" element={<StartChapter />} />
          <Route path="/trivia" element={<Trivia />} />
          <Route path="/edit-chapter/new" element={<ProtectedRoute>
            <NewChapter />
          </ProtectedRoute>} />
          <Route
            path="/editor"
            element={
              <ProtectedRoute>
                <TalkEditor />
              </ProtectedRoute>
            }
          />
          <Route
            path="/editor/:talkId"
            element={
              <ProtectedRoute>
                <EditorPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/national"
            element={
              <ProtectedRoute>
                <NationDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/edit-trivia"
            element={
              <ProtectedRoute>
                <EditTrivia />
              </ProtectedRoute>
            }
          />
          <Route
            path="/manage/:chapterId"
            element={
              <ProtectedRoute>
                <ChapterDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/email"
            element={
              <ProtectedRoute>
                <Email />
              </ProtectedRoute>
            }
          />
          <Route path="/links" element={<Linktree />} />
          <Route path="/welcome" element={<WelcomeScreen />} />
          <Route path="/slideshow/:talkId" element={<SlideshowPage />} />
          <Route path="/remote/:sessionId" element={<RemoteControlPage />} />
          <Route path="/talk/:talkId" element={<TalkPage />} />
          <Route path="/print/:talkId" element={<TalkPrint />} />
          <Route path="/handout/:talkId" element={<HandoutView />} />
          <Route path="/handout/:talkId/pdf" element={<PdfDownload />} />
          <Route path="/talks" element={<TalksGrid />} />
          <Route path="/login" element={<LoginPage />} />
          {/* <Route path="/users" element={<ProtectedRoute>
            <UsersPage />
          </ProtectedRoute>} /> */}
          <Route path="/schools/:schoolId" element={<ChapterPage />} />
          <Route path="/orders" element={<ProtectedRoute><Orders /></ProtectedRoute>} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
};

export default App;